import { Component, input, output, signal } from '@angular/core';

@Component({
  selector: 'nem-copy',
  standalone: false,
  template: `
    <div
      class="relative flex w-full shadow-sm rounded-lg overflow-hidden border border-slate-200 focus-within:ring-2 focus-within:ring-indigo-500/30 transition-shadow">
      @if (showMessage()) {
      <div
        class="absolute -top-10 right-0 bg-slate-800 text-white text-xs font-medium px-3 py-1.5 rounded-md shadow-lg animate-fade-in-up whitespace-nowrap z-[100]">
        Copied to clipboard!
        <div class="absolute -bottom-1 right-4 w-2 h-2 bg-slate-800 transform rotate-45"></div>
      </div>
      }

      <button
        type="button"
        class="px-4 py-2 bg-slate-50 text-slate-700 font-semibold text-sm border-r border-slate-200 hover:bg-slate-100 hover:text-indigo-600 transition-colors whitespace-nowrap"
        (click)="onGenerateLink($event)">
        Get link
      </button>

      <input
        type="text"
        [value]="textToCopy()"
        readonly
        class="flex-1 px-3 py-2 text-sm text-slate-500 bg-white focus:outline-none cursor-text w-full min-w-[150px]"
        placeholder="Share link..." />

      <button
        type="button"
        class="px-4 py-2 bg-slate-50 text-slate-600 border-l border-slate-200 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
        (click)="copyToClipboard($event)"
        title="Copy to clipboard">
        <i class="pi pi-clone"></i>
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        position: relative;
      }

      .animate-fade-in-up {
        animation: fadeInUp 0.2s ease-out forwards;
      }

      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(5px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `
  ]
})
export class NemCopyComponent {
  textToCopy = input<string>('');
  generateLink = output<void>();

  showMessage = signal(false);
  private _timerId: number | undefined;

  onGenerateLink(event: Event) {
    // Empêche le clic de remonter et de déclencher d'autres événements de la modale
    event.stopPropagation();
    this.generateLink.emit();
  }

  async copyToClipboard(event: Event) {
    // 1. Stoppe la propagation de l'événement pour éviter les conflits avec la modale PrimeNG
    event.stopPropagation();

    if (!this.textToCopy()) return;

    try {
      // 2. Utilisation de l'API moderne (Bypass totalement le DOM et le Focus Trap)
      await navigator.clipboard.writeText(this.textToCopy());

      // Affiche le popup de succès
      this.showMessage.set(true);

      if (this._timerId) {
        window.clearTimeout(this._timerId);
      }

      this._timerId = window.setTimeout(() => {
        this.showMessage.set(false);
        this._timerId = undefined;
      }, 2500);
    } catch (err) {
      console.error('Failed to copy text using Clipboard API: ', err);
      // Fallback très rare si l'utilisateur utilise un navigateur extrêmement vieux ou HTTP non sécurisé
    }
  }
}
